import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./Pages/Admin/Dashboard";
import Employees from "./Pages/Admin/Employees";
import Events from "./Pages/Admin/Events";
import Settings from "./Pages/Admin/Settings";
import Profile from "./Pages/Admin/Profile";
import Login from "./auth/login";
import Unauthorized from "./auth/Unauthorized";
import ProtectedRoute from "./Routes/ProtectedRoute";
import Sidebar from "./components/SideBar";
import NavBar from "./components/NavBar";
import ESideBar from "./components/ESideBar";
import E_Dashboard from "./Pages/Employee/E_Dashboard";
import E_PaySlips from "./Pages/Employee/E_PaySlips";
import E_NavhBar from "./Pages/Employee/E_NavBar";
import Payslips from "./Pages/Admin/Payslips";
import E_View from "./Pages/Employee/E_View";
import E_Attendance from "./Pages/Employee/E_Attendance";
import View from "./Pages/Admin/View";
import SalaryStructure from "./Pages/Admin/SalaryStructure";
import EditEmployee from "./Pages/Admin/EditEmployee";
import SearchBar from "./components/SearchBar";
import BottomNavBar from "./components/BottomNavBar";
import E_BottomNavBar from "./Pages/Employee/E_BottomNavBar";
import E_SearchBar from "./Pages/Employee/E_SearchBar";
import E_Profile from "./Pages/Employee/E_Profile";
import E_Settings from "./Pages/Employee/E_Settings";
import AuthCheck from "./Routes/AuthCheck";
import ForgotPassword from "./auth/ForgotPassword";
import ChangePassword from "./auth/ChangePassword";
import E_Leave from "./Pages/Employee/E_Leave"; // Add this import
import ManagerLeaveRequests from "./Pages/Employee/ManagerLeaveRequests";
import ManagerPayslipRequests from "./Pages/Employee/ManagerPayslipRequests";
import LeaveBalance from "./Pages/Admin/LeaveBalance";
import E_CompOff from "./Pages/Employee/E_CompOff";
import E_CompPay from "./Pages/Employee/E_CompPay";
import ManagerCompOffRequests from "./Pages/Employee/ManagerCompOffRequests";
import ManagerCompPayRequests from "./Pages/Employee/ManagerCompPayRequests";
import { useEffect, useState } from "react";
import { useUser } from "./context/UserContext";
import Annoucements from "./Pages/Annoucements";
import CreateAnnoucement from "./Pages/CreateAnnoucement";
import AnnoucementDetails from "./Pages/AnnoucementDetails";
import E_Events from "./Pages/Employee/E_Events";
import LoadingAnimation from "./components/LoadingAnimation";
import SavedAnnoucements from "./Pages/SavedAnnoucements";
import EditAnnouncements from "./Pages/EditAnnouncements";
import "react-datepicker/dist/react-datepicker.css";
import Attendance from "./Pages/Attendance";
import OnDuty from "./Pages/OnDuty";
import ManagerOnDutyRequests from "./Pages/ManagerOnDutyRequests";
import Employee_Attendance from "./Pages/HR/Employee_Attendance";
import HrSideBar from "./components/HrPageComponents/HrSideBar";
import HrNavBar from "./components/HrPageComponents/HrNavBar";
import HrSearchBar from "./components/HrPageComponents/HrSearchBar";
import HrBottomNavBar from "./components/HrPageComponents/HrBottomNavBar";
import ManageEmployees from "./Pages/HR/ManageEmployees";
import Event_Crud from "./Pages/HR/Event_Crud";
import Monthly_Attendance from "./Pages/HR/Monthly_Attendance";
import LeaveReports from "./Pages/HR/LeaveReports";
import CompOffReports from "./Pages/HR/CompOffReports";
import OnDutyReports from "./Pages/HR/OnDutyReports";
import HrDashboard from "./Pages/HR/HrDashboard";
import AddEmployee from "./Pages/HR/AddEmployee";
import InActiveEmloyees from "./Pages/HR/InActiveEmloyees";
import Departments from "./Pages/HR/Departments";
import ViewEmployee from "./Pages/HR/ViewEmployee";
import HR_LeaveBalance from "./Pages/HR/HR_LeaveBalance";
import CompPayReports from "./Pages/HR/CompPayReports";
import LeaveBalanceReports from "./Pages/HR/LeaveBalanceReports";
import E_Comps from "./Pages/Employee/E_Comps";
import PaySlipReports from "./Pages/HR/PayslipReports";


function AppContent() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true); // Add this line
  const { currentUser, loading } = useUser();

  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/changepassword" element={<ChangePassword />} />

         <Route path="events/annoucements" element={<Annoucements/>} />
         <Route path="events/detail/announcement/:annoucementid" element={<AnnoucementDetails/>} />

        {/* Admin Routes */}
        <Route element={<ProtectedRoute allowedRoles={["ADMIN","HR"]} />}>
          <Route
            path="/admin/*"
            element={
              <div className="flex min-h-screen">
                {/* Sidebar */}
                <div
                  className={`fixed w-72 top-0 left-0 h-full transition-transform duration-300 ease-in-out z-40 p-1
                    ${showSidebar ? "translate-x-0" : "-translate-x-full"} 
                    sm:translate-x-0 sm:block hidden`}
                >
                  <Sidebar />
                </div>

                {/* Main Content */}
                <div className="sm:ml-72 w-full">
                  {/* Fixed header container */}
                  <div className="fixed top-0 sm:left-72 left-0 w-full sm:w-auto bg-white sm:p-2 sm:right-0">
                    <div className="flex flex-col">
                      {/* Navbar */}
                      <div>
                        <NavBar setShowSidebar={setShowSidebar} />
                      </div>
                    </div>
                  </div>

                  {/* Content area */}
                  <div className="sm:mt-12 mt-16 p-4">
                    {/* Mobile Search */}
                    <div className=" sm:hidden w-full">
                      <SearchBar />
                    </div>
                    <div>
                      <Routes>
                        <Route path="dashboard" element={<Dashboard />} />in a
                        <Route path="employees" element={<Employees />} />
                        <Route path="events" element={<Events />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="profile" element={<Profile />} />
                        <Route
                          path="employees/payslips/:empid"
                          element={<Payslips />}
                        />
                        
                        <Route
                          path="employees/EditEmployee/:empid"
                          element={<EditEmployee />}
                        />
                        <Route
                          path="employees/View/:payid"
                          element={<View />}
                        />
                        <Route
                          path="employees/salary/:empid"
                          element={<SalaryStructure />}
                        />
                       
                        <Route path="employees/leavebalance/:empid" element={<LeaveBalance />} />
                      </Routes>
                    </div>
                  </div>

                  {/* Bottom Navigation */}
                  <div className="fixed bottom-0 left-0 right-0 h-16 sm:hidden block z-50">
                    <BottomNavBar />
                  </div>
                </div>
              </div>
            }
          />
        </Route>

        {/* Employee Routes */}
        <Route element={<ProtectedRoute allowedRoles={["EMPLOYEE", "MANAGER"]} />}>
          <Route
            path="/employee/*"
            element={
              <div className="flex min-h-screen">
                {/* Employee Sidebar */}
                <div className={`fixed  top-0 left-0 h-full transition-transform duration-300 ease-in-out z-40 p-1
                    ${showSidebar ? "translate-x-0" : "-translate-x-full"} 
                    sm:translate-x-0 sm:block hidden`}>
                  <ESideBar isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
                </div>

                {/* Main Content */}
                <div
                  className={`w-full transition-all duration-300 ease-in-out sm:ml-20 `}
                >
                  {/* Fixed header container */}
                  <div className={`fixed top-0  left-0 w-full sm:w-auto bg-slate-100 sm:p-2 sm:right-0  sm:ml-20`}>
                    <div className="flex flex-col">
                      {/* Navbar */}
                      <div className="">
                        <E_NavhBar setIsExpanded={setIsExpanded} />
                      </div>
                    </div>
                  </div>

                  {/* Content area - Updated padding and spacing */}
                  <div className="mt-16 p-4">

                    {/* Mobile Search 
                    <div className="sm:hidden w-full ">
                      <E_SearchBar />
                    </div>
                    */}
                    <div>
                      <Routes>
                        <Route path="dashboard" element={<E_Dashboard />} />
                        <Route path="payslips" element={<E_PaySlips />} />
                        <Route path="payslips/E_View/:payid" element={<E_View />} />
                        <Route path="attendance" element={
                         loading ? (
                         <LoadingAnimation />
                           ) : currentUser?.office === "SPC" ? (
                         <Attendance />
                          ) : (
                         <Events />
                        )
                        } />

                        <Route path="on-duty" element={
                         loading ? (
                         <LoadingAnimation />
                           ) : currentUser?.office === "SPC" ? (
                         <OnDuty />
                          ) : (
                         <Events />
                        )
                        } />


                        <Route path="leaves"
                         element={
                         loading ? (
                         <LoadingAnimation />
                           ) : currentUser?.office === "SPC" ? (
                         <E_Leave />
                          ) : (
                         <Events />
                        )
                        }
                        />
 
                        <Route path="leave-requests" element={<ManagerLeaveRequests />} />
                        <Route path="payslip-requests" element={<ManagerPayslipRequests />} />
                         <Route path="on-duty-requests" element={<ManagerOnDutyRequests />} />
                        <Route path="profile" element={<E_Profile />} />
                        <Route path="events/holidays" element={<E_Events/>} />

                        
                        <Route path="events/annoucements" element={<Annoucements/>} />
                        <Route path="events/detail/announcement/:annoucementid" element={<AnnoucementDetails/>} />
                        
                        
                        {/* Add HR specific routes */}
                        
                       <Route 
  path="comps"
  element={
    loading ? (
      <div>Loading</div>
    ) : currentUser?.office === "SPC" ? (
      <E_Comps />
    ) : (
      <Events />
    )
  }
/>
                       <Route 
  path="comp-off"
  element={
    loading ? (
      <div>Loading</div>
    ) : currentUser?.office === "SPC" ? (
      <E_CompOff />
    ) : (
      <Events />
    )
  }
/>

                        <Route 
  path="comp-pay"
  element={
    loading ? (
      <div>Loading</div>
    ) : currentUser?.office === "SPC" ? (
      <E_CompPay />
    ) : (
      <Events />
    )
  }
/>

                        <Route path="comp-off-requests" element={<ManagerCompOffRequests />} />
                        <Route path="comp-pay-requests" element={<ManagerCompPayRequests />} />
                      </Routes>
                    </div>
                  </div>

                  {/* Bottom Navigation - Updated z-index and shadow */}
                  <div className="fixed bottom-2 left-0 right-0 h-20 sm:hidden block z-30 shadow-lg w-full bg-white">
                    <E_BottomNavBar />
                  </div>
                </div>
              </div>
            }
          />
        </Route>
        

        {/*Hr Routes */}
        <Route element={<ProtectedRoute allowedRoles={["HR"]} />}>
          <Route
            path="/hr/*"
            element={
              <div className="flex min-h-screen">
                {/* Employee Sidebar */}
                <div className={`fixed  top-0 left-0 h-full transition-transform duration-300 ease-in-out z-40 p-1
                    ${showSidebar ? "translate-x-0" : "-translate-x-full"} 
                    sm:translate-x-0 sm:block hidden`}>
                  <HrSideBar isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
                </div>

                {/* Main Content */}
                <div
                  className={`w-full transition-all duration-300 ease-in-out sm:ml-20`}
                >
                  {/* Fixed header container */}
                  <div className={`fixed top-0  left-0 w-full sm:w-auto bg-slate-100 sm:p-2 sm:right-0 transition-all duration-300 ease-in-out sm:ml-20`}>
                    <div className="flex flex-col">
                      {/* Navbar */}
                      <div className="">
                        <HrNavBar setIsExpanded={setIsExpanded} />
                      </div>
                    </div>
                  </div>

                  {/* Content area - Updated padding and spacing */}
                  <div className="mt-16 p-4">
                    {/* Mobile Search 
                    <div className="sm:hidden w-full">
                      <HrSearchBar />
                    </div>
                      */}
                    <div>
                      <Routes>
                        <Route path="dashboard" element={<HrDashboard />} />

                        <Route path="employees/active" element={<ManageEmployees />} />
                         <Route path="employees/in-active" element={<InActiveEmloyees />} />
                         <Route path="leave-balance-manage" element={<HR_LeaveBalance />} />
                          <Route path="departments" element={<Departments />} />

                        <Route path="events/holidays" element={<Event_Crud />} />
                        <Route path="daily-attendance" element={<Employee_Attendance />} />
                        <Route path="monthly-attendance" element={<Monthly_Attendance />} />
                        <Route path="leave-reports" element={<LeaveReports />} />
                        <Route path="payslip-reports" element={<PaySlipReports />} />
                        <Route path="leave-balance-reports" element={<LeaveBalanceReports />} />
                        <Route path="compOff-reports" element={<CompOffReports />} />
                        <Route path="onduty-reports" element={<OnDutyReports />} />
                        <Route path="comppay-reports" element={<CompPayReports />} />

                        <Route path="events/annoucements" element={<Annoucements/>} />
                        <Route path="events/detail/announcement/:annoucementid" element={<AnnoucementDetails/>} />
                         <Route path="events/saved/annoucements" element={<SavedAnnoucements/>} />
                         <Route path="events/create/annoucement" element={<CreateAnnoucement/>} />
                        
                         <Route path="events/edit/annoucement/:annoucementid" element={<EditAnnouncements/>} />
                        <Route path="employees/payslips/:empid" element={<Payslips />} />
                        <Route
                          path="AddEmployee"
                          element={<AddEmployee />}
                        />
                         <Route
                          path="view-employee/:empid"
                          element={<ViewEmployee />}
                        />
                        <Route path="employees/EditEmployee/:empid" element={<EditEmployee />} />
                        <Route path="employees/View/:payid" element={<E_View />} />
                        <Route path="employees/salary/:empid" element={<SalaryStructure />} />
                        <Route path="employees/leavebalance/:empid" element={<LeaveBalance />} />

                      </Routes>
                    </div>
                  </div>

                  {/* Bottom Navigation - Updated z-index and shadow */}
                  <div className="fixed bottom-0 left-0 right-0 h-20 sm:hidden block z-30 shadow-lg w-full bg-white">
                    <HrBottomNavBar />
                  </div>
                </div>
              </div>
            }
          />
        </Route>




        {/* CEO Routes - CEO as Super Manager handling only requests */}
        <Route element={<ProtectedRoute allowedRoles={["CEO"]} />}>
          <Route
            path="/ceo/*"
            element={
              <div className="flex min-h-screen">
                {/* CEO Sidebar */}
                <div className={`fixed top-0 left-0 h-full transition-transform duration-300 ease-in-out z-40 p-1
                    ${showSidebar ? "translate-x-0" : "-translate-x-full"} 
                    sm:translate-x-0 sm:block hidden`}>
                  <ESideBar isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
                </div>

                {/* Main Content */}
                <div className={`w-full transition-all duration-300 ease-in-out sm:ml-20`}>
                  {/* Fixed header container */}
                  <div className={`fixed top-0 left-0 w-full sm:w-auto bg-slate-100 sm:p-2 sm:right-0 sm:ml-20`}>
                    <div className="flex flex-col">
                      {/* Navbar */}
                      <div className="">
                        <E_NavhBar setIsExpanded={setIsExpanded} />
                      </div>
                    </div>
                  </div>

                  {/* Content area */}
                  <div className="mt-16 p-4">
                    <div>
                      <Routes>
                        <Route path="leave-requests" element={<ManagerLeaveRequests />} />
                        <Route path="comp-off-requests" element={<ManagerCompOffRequests />} />
                        <Route path="comp-pay-requests" element={<ManagerCompPayRequests />} />
                        <Route path="payslip-requests" element={<ManagerPayslipRequests />} />
                        {/* Default redirect to leave-requests */}
                        <Route path="*" element={<ManagerLeaveRequests />} />
                      </Routes>
                    </div>
                  </div>

                  {/* Bottom Navigation */}
                  <div className="fixed bottom-2 left-0 right-0 h-20 sm:hidden block z-30 shadow-lg w-full bg-white">
                    <E_BottomNavBar />
                  </div>
                </div>
              </div>
            }
          />
        </Route>




      </Routes>

    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;